import { P2, P1 } from '@moneymade/moneymade-ui'
import PropTypes from 'prop-types'

import styles from './KnowPointsCard.module.scss'

const KnowPointsCard = ({ didYouKnow }) => (
  <div className={styles.KnowPointsCard}>
    <P1 weight="normal" className={styles.Title}>
      Did you Know
    </P1>
    <ul>
      {didYouKnow.map(({ text }, index) => (
        <li key={index} className={styles.Points}>
          <img
            src="https://assets.moneymade.io/images/AssetPage/pointStar.svg"
            alt="poitStar"
            className={`${styles.Image}`}
          />
          <P2 weight="light">{text}</P2>
        </li>
      ))}
    </ul>
  </div>
)

KnowPointsCard.propTypes = {
  didYouKnow: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string
    })
  )
}

KnowPointsCard.defaultProps = {
  didYouKnow: []
}

export default KnowPointsCard
